class Panels{
  static init(){
    const panels = document.querySelectorAll('.panel');
    panels.forEach(panel =>{
      panel.querySelectorAll('.btn-close, .dimmer').forEach(el => {
        el.addEventListener('click', ()=>{
          panel.classList.remove('active');
          document.body.classList.remove('modal-open');
        })
      })
    })

    document.querySelectorAll('*[data-action="panel-open"]').forEach(el=>{
      const target = 'panel-'+el.getAttribute('data-target');

      el.addEventListener('click', evt => {
        evt.preventDefault();
        document.getElementById(target).classList.add('active');
        document.body.classList.add('modal-open');
        return false;
      })
    });

  }
}

export {Panels}